// toast.js
import Vue from "vue";
import index from "./index.vue";

const ToastConstructor = Vue.extend(index);

let instance;
function load() {
  if (!instance) {
    instance = new ToastConstructor();
    instance.$mount();
    if (document.body) {
      document.body.appendChild(instance.$el);
    }
  }
  instance.loading();
}
function close() {
  instance.hide();
  //删除dom
}

export default {
  load,
  hide: close,
};
